"use client";

import { Suspense } from "react";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import PartnerSignupContent from "./components/PartnerSignupContent";

function PartnerSignupSkeleton() {
  return (
    <div className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="animate-pulse space-y-8">
          <div className="h-16 bg-neutral-800 rounded max-w-xl mx-auto" />
          <div className="h-96 bg-neutral-800 rounded" />
        </div>
      </div>
    </div>
  );
}

export default function PartnerSignupPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-background text-foreground pt-20">
        <Suspense fallback={<PartnerSignupSkeleton />}>
          <PartnerSignupContent />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}